import { css } from '@emotion/react';
import { colors } from '../../../styles';

export const OnboardingButton = ({
  currentSlide,
  onClick,
  children,
  disabled,
}: {
  currentSlide?: number;
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      css={css`
        width: 100%;
        height: 60px;
        background-color: ${disabled ? colors.cloud : colors.petrolBlue};
        color: ${disabled ? colors.silver : colors.sugar};
        border: none;
        border-radius: 4px;
        font-size: 18.4px;
        font-weight: 500;
        cursor: ${disabled ? 'not-allowed' : 'pointer'};
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: ${currentSlide === 5 ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'};
        margin-top: ${currentSlide === 5 ? '20px' : '0'};
        opacity: ${disabled ? 0.6 : 1};
        transition: all 0.2s ease;

        html[data-theme='dark'] & {
          background-color: ${disabled ? colors.silver : colors.petrolBlue};
          color: ${disabled ? colors.cloud : colors.sugar};
        }
      `}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
